import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { BUSCA_CONSULTAS_INIT_IQVIA, EXECUTAR_VALIDACAO_INIT_IQVIA } from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { buscaConsultasSuccessIqvia, executarValidacaoSuccessIqvia, requestErrorValidacaoIqvia } from './actions';
import { buscaConsultasIqvia, executarValidacaoIqvia } from 'src/integracoes/servicos/mongo-atlas/funcoes/validacaoRelatoriosIqvia';


// Executar validação Iqvia
const fetchExecutarValidacao = async (payload: any) => {
  try {
    const { status, dados, mensagem } = await executarValidacaoIqvia(payload);
    if (status) {
      return { isError: false, data: dados, errorMessage: mensagem };
    }
    return { isError: true, data: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseExecutarValidacao({ payload }: any) {
  try {
    const { isError, data, errorMessage } = yield call(fetchExecutarValidacao, payload);
    if (!isError) {
      yield put(executarValidacaoSuccessIqvia({ dados: data, mensagem: errorMessage }));
    } else {
      yield put(requestErrorValidacaoIqvia(errorMessage));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(requestErrorValidacaoIqvia(mensagem));
  }
}

function* watchExecutarValidacaoInit() {
  yield takeEvery(EXECUTAR_VALIDACAO_INIT_IQVIA, parseExecutarValidacao);
}

// Busca consultas Iqvia
const fetchBuscaConsultasIqvia = async (payload: any) => {
  try {
    const { status, dados, mensagem } = await buscaConsultasIqvia(payload);
    if (status) {
      return { isError: false, data: dados, errorMessage: mensagem };
    }
    return { isError: true, data: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseBuscaConsultasIqvia({ payload }: any) {
  try {
    const { isError, data, errorMessage } = yield call(fetchBuscaConsultasIqvia, payload);
    if (!isError) {
      yield put(buscaConsultasSuccessIqvia({ consultas: data, mensagem: errorMessage }));
    } else {
      yield put(requestErrorValidacaoIqvia(errorMessage));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(requestErrorValidacaoIqvia(mensagem));
  }
}

function* watchBuscaConsultasInit() {
  yield takeEvery(BUSCA_CONSULTAS_INIT_IQVIA, parseBuscaConsultasIqvia);
}

export default function* validacaoRelatoriosIqviaSaga() {
  yield all([
    fork(watchExecutarValidacaoInit),
    fork(watchBuscaConsultasInit)
  ]);
}
